<template>
	<div class="main">
		<hwk-header></hwk-header>
		<div class="warp flex o-d-main">
			<div class="o-d-l">
				<div class="back pointer" @click="goBack">
					<i class="el-icon-arrow-left"></i><span>申请售后</span>
				</div>
				<div class="apply-type flex">
					<div class="l">选择售后类型</div>
					<div class="r flex">
						<div class="i pointer flex" @click="changeType(1)"><img src="@/assets/radio2.png"
								v-if="type==1" /><img src="@/assets/radio1.png" v-else /><span>退货退款</span></div>
						<div class="i pointer flex" @click="changeType(2)"><img src="@/assets/radio2.png"
								v-if="type==2" /><img src="@/assets/radio1.png" v-else /><span>补发配件</span></div>
						<div class="i pointer flex" @click="changeType(3)"><img src="@/assets/radio2.png"
								v-if="type==3" /><img src="@/assets/radio1.png" v-else /><span>订单异常</span></div>
					</div>
				</div>
				<div class="apply-pj-addr" v-if="type == 2">
					<div class="title flex">
						<div class="l">配件信息</div>
						<div class="r" @click="dialogShow = true">
							<img src="@/assets/add2.png" alt="" /><span>添加配件</span>
						</div>
					</div>
					<div class="pj" v-if="cartlist.length > 0">
						<span v-for="(item,index) in cartlist"
							:key="index">{{item.sku_name_string}}×{{item.number}}、</span>
					</div>

				</div>
				<div class="apply-pj-addr" v-if="type == 2">
					<div class="title flex">
						<div class="l">收货地址</div>
						<div class="r pointer" @click="dialogFormVisible=true">
							<img src="@/assets/w2.png" alt="" /><span>修改地址</span>
						</div>
					</div>
					<div class="address">
						<div class="l">
							<i class="el-icon-location"></i>
						</div>
						<div class="r">
							<p>{{form.address}}</p>
							<p><span>{{form.name}}</span><span>{{form.phone}}</span><span>{{form.email}}</span></p>
						</div>
					</div>
				</div>
				<div class="apply-uploads">
					<div class="item">
						<div class="title">情况说明</div>
						<div class="textarea"><el-input type="textarea" :rows="2" placeholder="请输入" v-model="explain">
							</el-input></div>
					</div>
					<div class="item">
						<div class="title">
							上传图片/视频
							<span>（最多上传9个文件，每个文件大小不超过5M，支持jpg，png，MP4格式文件）</span>
						</div>
						<div class="hwk-upload">
							<!-- <el-upload class="avatar-uploader" :action="$upload" list-type="picture-card"
								:headers="headers" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
								:limit="9" :on-success="imgSuccess" :on-error="imgError" :on-change="imgChange"
								:before-upload="beforeAvatarUpload" :file-list="fileList1">
								<img src="@/assets/add.png" alt="" class="add" />
							</el-upload>
							<el-dialog :visible.sync="dialogVisible">
								<img width="100%" :src="dialogImageUrl" alt="">
							</el-dialog> -->
							<div class="uploads flex">
								<div class="i" v-for="(item,index) in imgs" :key="index">
									<img :src="item.fullurl" class="img"
										v-if="['image/jpeg', 'image/png', 'image/gif'].includes(item.type)" />
									<video :src="item.fullurl" v-if="item.type === 'video/mp4'" class="img"></video>
									<img src="@/assets/delete.png" alt="" class="delete" @click="delImg(index)" />
								</div>
								<div class="i" @click="upload(1)">
									<img src="@/assets/add.png" alt="" class="add" />
									<input type="file" ref="imgInput" @change="handleImgUpload" style="display: none"
										:multiple="false" />
								</div>
							</div>
						</div>
					</div>
					<div class="item">
						<div class="title">
							上传文件
							<span>（最多上传9个文件，每个文件大小不超过5M，支持WPS，PDF，图片格式文件）</span>
						</div>
						<div class="hwk-upload">
							<!-- <el-upload class="avatar-uploader" :action="$upload" list-type="picture-card"
								:headers="headers" :on-remove="handleRemove2" :limit="9" :on-success="fileSuccess"
								:on-error="fileError" :on-change="fileChange" :before-upload="beforeAvatarUpload2"
								:file-list="fileList2">
								<img src="@/assets/add.png" alt="" class="add" />
							</el-upload> -->
							<div class="uploads flex">
								<div class="i" v-for="(item,index) in files" :key="index">

									<img :src="item.fullurl" class="img"
										v-if="['image/jpeg', 'image/png', 'image/gif'].includes(item.type)" />
									<img src="@/assets/word.png" class="img"
										v-if="item.type === 'application/msword'||item.type==='application/vnd.openxmlformats-officedocument.wordprocessingml.documenrt'" />
									<img src="@/assets/ppt.png" class="img"
										v-if="item.type==='application/vnd.ms-powerpoint'||item.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'" />
									<img src="@/assets/excel.png" class="img"
										v-if="item.type==='application/vnd.ms-excel'||item.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" />
									<img src="@/assets/pdf.png" class="img" v-if="item.type === 'application/pdf'" />
									<img src="@/assets/delete.png" alt="" class="delete" @click="delFile(index)" />
								</div>
								<div class="i" @click="upload(2)">
									<img src="@/assets/add.png" alt="" class="add" />
									<input type="file" ref="fileInput" @change="handleFileUpload" style="display: none"
										:multiple="false" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="o-d-goods">
					<div class="item1">
						<div class="i i1">商品</div>
						<div class="i i2">
							价格
						</div>
					</div>
					<div class="item" v-for="(item,index) in list" :key="index">
						<div class="img">
							<img :src="http + item.goods_image" alt="" />
						</div>
						<div class="con">
							<div class="name">{{item.goods_title}}</div>
							<div class="p">{{data.warehouse_string}}</div>
							<div class="p">{{item.goods_child_sku_string}}</div>

						</div>
						<div class="price">
							<p>￥{{item.price}}</p>
							<p>x{{item.number}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="o-d-r">
				<div class="title">售后详情</div>
				<div class="list">
					<div class="item">
						<div class="l">售后类型</div>
						<div class="r" v-if="type == 0">-</div>
						<div class="r" v-if="type == 1">退货退款</div>
						<div class="r" v-if="type == 2">补发配件</div>
						<div class="r" v-if="type == 3">订单异常</div>
					</div>
					<div class="item" v-if="type == 1">
						<div class="l">商品数量</div>
						<div class="r">共<b class="num-din">{{goodsNum}}</b>件</div>
					</div>
					<div class="item" v-if="type == 1">
						<div class="l">退款金额</div>
						<div class="r">￥<b class="num-din">{{refund}}</b></div>
					</div>
					<div class="item" v-if="type == 2">
						<div class="l">配件数量</div>
						<div class="r"><b class="num-din">{{getNumber(reissue_arr)}}</b> </div>
					</div>
				</div>
				<div class="hr"></div>
				<div class="r-btns flex">
					<div class="btn1 pointer" @click="goBack">返回</div>
					<div class="btn2 pointer" @click="submit">确认提交</div>
				</div>
				<div class="hr"></div>
				<div class="title">订单信息</div>
				<div class="list">
					<div class="item">
						<div class="l">系统订单</div>
						<div class="r pointer flex">{{data.order_number}} <img src="@/assets/copy.png"
								@click="copyText(data.order_number)" /></div>
					</div>
					<div class="item">
						<div class="l">创建时间</div>
						<div class="r">
							{{$timeFormat(data.updatetime,'yyyy-mm-dd')||$timeFormat(data.createtime,'yyyy-mm-dd')}}
						</div>
					</div>
					<div class="item">
						<div class="l">商品数量</div>
						<div class="r">共 <b class="num-din">{{goodsNum}}</b> 件</div>
					</div>
					<div class="item">
						<div class="l">商品总价</div>
						<div class="r">￥<b class="num-din">{{data.pay_price}}</b></div>
					</div>
					<div class="item">
						<div class="l">运费</div>
						<div class="r">￥<b
								class="num-din">{{data && data.order_address && data.order_address.logistics_price}}</b>
						</div>
					</div>
					<div class="item">
						<div class="l">签名服务</div>
						<div class="r">￥<b class="num-din">{{data.sign_price}}</b></div>
					</div>
				</div>
			</div>
		</div>
		<navigation></navigation>





		<el-dialog title="修改地址" :visible.sync="dialogFormVisible" width="980px">
			<div class="textarea">
				<el-input type="textarea" :rows="3" placeholder="在这里粘贴或输入地址..." v-model="textarea">
				</el-input>
				<el-button type="primary" size="small" @click="analysis">识别地址</el-button>
			</div>
			<div class="tips flex">
				<i class="el-icon-warning-outline"></i>
				<span>自动输入是机器学习的结果，无法保证完全正确，请检查下方地址。</span>
			</div>

			<el-form :model="form" label-position="left" :rules="rules" ref="ruleForm">
				<table class="table-form">
					<tr>
						<td>
							<el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
								<el-input v-model="form.name" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
						<td>
							<el-form-item label="电话" :label-width="formLabelWidth" prop="phone">
								<el-input v-model="form.phone" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址一" :label-width="formLabelWidth" prop="address_one">
								<el-input v-model="form.address_one" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址二" :label-width="formLabelWidth">
								<el-input v-model="form.address_two" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-form-item label="地址三" :label-width="formLabelWidth">
								<el-input v-model="form.address_three" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td>
							<!-- <el-form-item label="门牌号" :label-width="formLabelWidth" prop="house_number">
								<el-input v-model="form.house_number" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item> -->
							<el-form-item label="邮编" :label-width="formLabelWidth" prop="zip_code">
								<el-input v-model="form.zip_code" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
						<td>
							<el-form-item label="邮箱" :label-width="formLabelWidth">
								<el-input v-model="form.email" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
					<tr>
						<td>
							<el-form-item label="省/州/府" :label-width="formLabelWidth" prop="province">
								<el-input v-model="form.province" autocomplete="off" placeholder="请输入"></el-input>

							</el-form-item>
						</td>
						<td>
							<el-form-item label="城市/区" :label-width="formLabelWidth" prop="city"
								:disabled="!form.province">
								<el-input v-model="form.city" autocomplete="off" placeholder="请输入"></el-input>

							</el-form-item>
						</td>
					</tr>
					<tr>
						<!-- <td>
							<el-form-item label="邮编" :label-width="formLabelWidth" prop="zip_code">
								<el-input v-model="form.zip_code" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td> -->
						<td colspan="2">
							<el-form-item label="国家" :label-width="formLabelWidth" prop="country">
								<el-input v-model="form.country" autocomplete="off" placeholder="请输入"></el-input>
							</el-form-item>
						</td>
					</tr>
				</table>

				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitAddress('ruleForm')" size="small">保 存</el-button>
			</div>
		</el-dialog>


		<el-dialog title="添加配件" :center="false" :visible.sync="dialogShow" width="540px">
			<div class="addpj">
				<div class="search-top">
					<input type="text" v-model="search" placeholder="输入关键词进行查询" />
					<div class="btn" @click="searchpj">搜索</div>
				</div>
				<div class="title flex">
					<div class="i i1">配件名称</div>
					<div class="i i2">补发数量</div>
				</div>
				<div class="item flex" v-for="(item,index) in pjlist" :key="index">
					<div class="l flex">
						<img :src="http + item.goods_item.image" alt="" />
						<div class="con">
							<div class="name">{{item.sku_name}}</div>
							<div class="info">{{item.sku_string}}</div>
						</div>
					</div>
					<div class="r">
						<el-input-number size="small" style="width: 100px;" v-model="item.number" :min="0" :max="99999"
							label="描述文字" @change="handleChange"></el-input-number>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer2">
				<div class="l">
					配件数量<span>{{getNumber(pjlist)}}</span>
				</div>
				<el-button type="primary" @click="confirm">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation
		},
		data() {
			return {
				search: '',
				formLabelWidth: '80px',
				dialogFormVisible: false,
				http: this.$imgUrl,
				list: [],
				pageSize: 0,
				page: 1,
				dialogImageUrl: '',
				dialogVisible: false,
				dialogShow: false,
				data: {},
				type: 1,
				explain: '',
				explain_images: '',
				explain_files: '',
				receive_name: "",
				receive_phone: '',
				receive_address: "",
				receive_email: "",
				reissue_arr: [],
				headers: {
					token: localStorage.getItem('token')
				},
				fileList1: [],
				fileList2: [],
				selectedFiles: [],
				files: [],
				imgs: [],
				pjlist: [],
				form: {
					address: "",
					address_one: "",
					address_three: "",
					address_two: "",
					city: "",
					country: "",
					email: "",
					// house_number: "",
					name: "",
					province: "",
					phone: "",
					zip_code: "",
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}],
					address_one: [{
						required: true,
						message: '请输入地址1',
						trigger: 'blur'
					}],
					// house_number: [{
					// 	required: true,
					// 	message: '请输入门牌号',
					// 	trigger: 'blur'
					// }],
					// email: [{
					// 	required: true,
					// 	message: '请输入邮箱',
					// 	trigger: 'blur'
					// }],
					country: [{
						required: true,
						message: '请选择国家',
						trigger: 'change'
					}],
					province: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					city: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					zip_code: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}]
				},
				list: [],
				goodsNum: 0,
				refund: 0,
				pjNum: 0,
				textarea: '',
				cartlist: [],

			};
		},
		created() {
			this.id = this.$route.query.id
			this.getData();
			this.getpjlist()
		},
		computed: {
			getNumber() {
				return (list) => {
					return list.reduce((acc, curr) => acc + curr.number, 0);
				}
			}
		},
		methods: {
			analysis() {
				if (!this.textarea) {
					this.$message.error('请输入要识别的内容!');
					return
				}
				this.$http.post('/api/order/address_analysis', {
					address: this.textarea,
				}).then(res => {
					if (res.code == 1) {
						this.form.address_one = res.data.result.route + res.data.result.streetNum
						this.form.city = res.data.result.city
						this.form.country = res.data.result.country
						this.form.email = res.data.email
						// this.form.house_number = res.data.result.streetNum
						this.form.name = res.data.name
						this.form.province = res.data.result.province
						this.form.phone = res.data.phone_arr.length > 0 ? res.data.phone_arr[0] : ''
						this.form.zip_code = res.data.result.postcode
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}


				});
			},
			submitAddress(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.dialogFormVisible = false
						this.form.address =
							`${this.form.address_one}_${this.form.city}_${this.form.province}_${this.form.country}`
					} else {
						this.$message.error('您有信息未填写!');

					}
				});

			},


			confirm() {
				this.dialogShow = false
				this.reissue_arr = this.pjlist.filter(item => item.number > 0)
				let list = this.pjlist.filter(item => item.number > 0)

				console.log(this.cartlist, 8888888888)
				if (this.cartlist.length == 0) {
					this.cartlist = list
				} else {
					list.forEach(item => {

						let index = this.cartlist.findIndex(item2 => item2.id == item.id)
						if (index > -1) {
							this.cartlist[index].number = item.number
						} else {
							this.cartlist.push(item)
						}
					})
				}

				console.log(this.cartlist, 555555555555)


			},
			handleChange(value) {
				console.log(value);
				this.$forceUpdate()
			},
			handleImgUpload(event) {
				console.log(event, '---------')
				const file = event.target.files[0];
				const isJPG = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4'].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;
				if (!isJPG) {
					this.$message.error('只能上传图片/视频格式!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片/视频大小不能超过 5MB!');
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const formData = new FormData();
				formData.append('file', file);
				this.$http.post('/api/common/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'token': localStorage.getItem('token')
					}
				}).then(response => {
					console.log('上传成功:', response.data);

					this.imgs.push({
						url: response.data.url,
						fullurl: response.data.fullurl,
						type: file.type
					})
					loading.close();

				}).catch(error => {
					console.error('上传失败:', error);
					loading.close();
				});

			},
			handleFileUpload(event) {
				console.log(event, '---------')
				const file = event.target.files[0];
				const isJPG = file.type === 'application/pdf' || file.type ===
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type ===
					'application/msword' || file.type ===
					'application/vnd.openxmlformats-officedocument.presentationml.presentation' || file.type ===
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || ['image/jpeg', 'image/png',
						'image/gif'
					].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;

				if (!isJPG) {
					this.$message.error('上传文件只能是 doc、docx、 pdf、图片格式!');
					return
				}
				// if (!isLt2M) {
				// 	this.$message.error('上传文件大小不能超过 5MB!');
				// 	return
				// }

				const loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});


				const formData = new FormData();
				formData.append('file', file);
				this.$http.post('/api/common/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'token': localStorage.getItem('token')
					}
				}).then(response => {
					console.log('上传成功:', response);
					if (response.code == 0) {
						this.$message.error(response.msg);
						return
					}

					this.files.push({
						url: response.data.url,
						fullurl: response.data.fullurl,
						type: file.type
					})
					loading.close();


				}).catch(error => {
					console.error('上传失败:', error);
					loading.close();
				});

			},


			delFile(index) {
				this.files.splice(index, 1);
			},
			delImg(index) {
				this.imgs.splice(index, 1);
			},
			upload(i) {
				if (i == 1) {
					this.$refs.imgInput.click()
				} else {
					this.$refs.fileInput.click()
				}
			},


			// 文件移除
			handleRemove2(file, fileList) {
				console.log(file, fileList, 'handleRemove2');
				this.fileList2 = fileList
			},
			//文件上传校验
			beforeAvatarUpload2(file) {
				console.log(file.type, 'file.type')
				const isJPG = file.type === 'application/pdf' || file.type ===
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type ===
					'application/msword' || file.type ===
					'application/vnd.openxmlformats-officedocument.presentationml.presentation' || file.type ===
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				const isLt2M = file.size / 1024 / 1024 < 5;

				if (!isJPG) {
					this.$message.error('上传文件只能是 doc、docx、 pdf 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},
			fileChange(file, fileList) {
				// console.log('fileChange', file, fileList)
			},
			fileError(err, file, fileList) {
				// console.log('fileError', err, file, fileList)
			},
			fileSuccess(response, file, fileList) {
				// console.log('fileSuccess', response, file, fileList)
				this.fileList2.push({
					name: file.name,
					url: response.data.fullurl,
					url2: response.data.url,
				})
			},

			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			// 图片视频移除
			handleRemove(file, fileList) {
				console.log(file, fileList, 'handleRemove');
				this.fileList1 = fileList
			},
			// 图片视频上传校验
			beforeAvatarUpload(file) {
				const isJPG = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传图片视频大小不能超过 5MB!');
				}
				return isJPG && isLt2M;
			},
			imgChange(file, fileList) {
				// console.log('imgChange', file, fileList)
			},
			imgError(err, file, fileList) {
				// console.log('imgError', err, file, fileList)
			},
			imgSuccess(response, file, fileList) {
				// console.log('imgSuccess', response, file, fileList)
				this.fileList1.push({
					name: file.name,
					url: response.data.fullurl,
					url2: response.data.url,
				})
			},
			async copyText(data) {
				try {
					await navigator.clipboard.writeText(data);
					this.$message({
						type: 'success',
						message: '复制成功!'
					});
				} catch (err) {
					this.$message({
						message: '复制失败！你的的浏览器不支持自动复制,请手动复制!',
						type: 'warning'
					});

				}
			},
			submit() {
				if (this.type == 0) {
					this.$message({
						message: '请选择售后类型',
						type: 'warning'
					});
					return
				}
				if (!this.explain) {
					this.$message({
						message: '请填写情况说明',
						type: 'warning'
					});
					return
				}
				if (this.imgs.length > 9) {
					this.$message({
						message: '图片/视频数量超过9个',
						type: 'warning'
					});
					return
				}
				if (this.files.length > 9) {
					this.$message({
						message: '文件数量超过9个',
						type: 'warning'
					});
					return
				}
				let images = this.imgs.length > 0 ? this.imgs.map(item => item.url).toString() : ""
				let files = this.files.length > 0 ? this.files.map(item => item.url).toString() : ""
				if (this.type == 2 && this.reissue_arr.length == 0) {
					this.$message({
						message: '请选择配件',
						type: 'warning'
					});
					return
				}
				let arr = ''
				// if (this.reissue_arr.length > 0 && this.type == 2) {
				// 	let arry = this.reissue_arr.map(item => {
				// 		return {
				// 			goods_child_id: item.id,
				// 			number: item.number,
				// 		}
				// 	})
				// 	this.reissue_arr.forEach(item => item.goods_child_id = item.id)
				// 	arr = JSON.stringify(this.reissue_arr)
				// }


				if (this.cartlist.length > 0 && this.type == 2) {
					let arry = this.cartlist.map(item => {
						return {
							goods_child_id: item.id,
							number: item.number,
						}
					})
					this.cartlist.forEach(item => item.goods_child_id = item.id)
					arr = JSON.stringify(this.cartlist)
				}




				this.$http.post('/api/order_refund/apply', {
					type: this.type,
					explain: this.explain,
					explain_images: images,
					explain_files: files,
					receive_name: this.form.name,
					receive_phone: this.form.phone,
					receive_address: this.form.address,
					receive_email: this.form.email,
					reissue_arr: arr,
					order_id: this.id,
					...this.form
				}).then(res => {
					if (res.code == 1) {
						this.$message({
							type: 'success',
							message: '申请成功!'
						});
						setTimeout(() => {
							this.$router.push({
								path: "/afterSalesList"
							});
						}, 1000)

					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}


				});

			},

			goBack() {
				this.$router.go(-1);
			},
			changeType(i) {
				this.type = i
			},
			getData() {

				this.$http.get('/api/order/info', {
					params: {
						id: this.id
					}
				}).then(res => {
					console.log(res)
					this.data = res.data
					this.form = {
						address: `${res.data.order_address.address_one}_${res.data.order_address.city}_${res.data.order_address.province}_${res.data.order_address.country}`,
						name: res.data.order_address.name,
						phone: res.data.order_address.phone,
						email: res.data.order_address.email,
						address_one: res.data.order_address.address_one,
						address_three: res.data.order_address.address_three,
						address_two: res.data.order_address.address_two,
						city: res.data.order_address.city,
						country: res.data.order_address.country,
						// house_number: res.data.order_address.house_number,
						province: res.data.order_address.province,
						zip_code: res.data.order_address.zip_code,
					}
					this.list = res.data.order_goods
					this.goodsNum = this.list.reduce((acc, curr) => acc + curr.number, 0);
					this.refund = parseFloat(res.data.pay_price) + parseFloat(res.data.sign_price)
				});

			},
			searchpj() {
				this.getpjlist()
			},
			getpjlist() {
				this.$http.get('/api/goods/goods_child', {
					params: {
						page: 1,
						limit: 9999,
						search: this.search,
						type: 2
					}
				}).then(res => {
					console.log(res)
					this.pjlist = res.data.data
					this.pjlist.forEach(item => item.number = 0)
					if (this.cartlist.length > 0 && this.pjlist.length > 0) {
						this.cartlist.forEach(item => {
							let index = this.pjlist.findIndex(item2 => item2.id == item.id)

							if (index > -1) {
								this.pjlist[index].number = item.number
							}
						})
					}

				});
			},


			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},

		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.dialog-footer2 {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.l {
			font-size: 14px;
			color: #868E99;

			span {
				color: @color1;
				margin-left: 5px;
			}
		}
	}

	.addpj {
		max-height: 560px;
		overflow-y: auto;

		.search-top {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;
			height: 40px;
			background: #FFFFFF;
			border-radius: 6px 6px 6px 6px;
			border: 1px solid #D8D8D8;
			padding: 0 10px;
			box-sizing: border-box;
			margin-bottom: 20px;

			input {
				flex: 1;
				height: 30px;
				line-height: 30px;
				width: 1px;
				margin-right: 20px;
				border: none;
				color: #666;
				font-size: 14px;
			}

			.btn {
				width: 68px;
				height: 34px;
				line-height: 34px;
				color: #fff;
				font-size: 14px;
				text-align: center;
				background: #FF6A00;
				border-radius: 6px 6px 6px 6px;
			}
		}

		.title {
			font-size: 14px;
			color: @color1;
			height: 32px;
			line-height: 32px;
			background: #F7F9FA;
			border-radius: 6px 6px 6px 6px;

			.i {
				text-align: left;
				text-indent: 10px;
			}

			.i1 {
				flex: 1;
				width: 1px;
			}

			.i2 {
				width: 100px;
			}
		}

		.item {
			padding: 10px 0;
			border-bottom: 1px solid #eee;

			.l {
				flex: 1;
				width: 1px;

				img {
					width: 40px;
					height: 40px;
					background: #FFFFFF;
					border-radius: 6px 6px 6px 6px;
					border: 1px solid #D8D8D8;
				}

				.con {
					flex: 1;
					width: 1px;
					margin-left: 10px;

					.name {
						height: 20px;
						line-height: 20px;
						font-size: 14px;
						color: @color1;
						text-align: left;
					}

					.info {
						height: 20px;
						line-height: 20px;
						font-size: 12px;
						color: #868E99;
						text-align: left;

					}
				}
			}

			.r {}
		}

	}

	.o-d-main {
		margin: 20px auto;
		background-color: #fff;
		padding: 20px;
		box-sizing: border-box;
		border-radius: 10px;
		align-items: flex-start;
		justify-content: space-between;

		.o-d-l {
			flex: 1;
			width: 1px;
			margin-right: 20px;

			.apply-pj-addr {
				.pj {
					padding: 10px;
					background: #FFFFFF;
					border-radius: 6px 6px 6px 6px;
					border: 1px solid #D8D8D8;
					font-size: 14px;
					color: @color1;
					line-height: 30px;
					text-align: left;
				}

				.title {
					height: 40px;
					line-height: 40px;

					.l {
						text-align: left;
						font-size: 14px;
						color: @color1;
					}

					.r {
						flex: 1;
						width: 1px;
						display: flex;
						align-items: center;
						justify-content: flex-end;

						img {
							width: 14px;
							height: 14px;
						}

						span {
							color: @color2;
							font-size: 12px;
							margin-left: 5px;
						}
					}
				}
			}

			.apply-uploads {
				.item {
					padding: 10px 0;

					.title {
						text-align: left;
						font-size: 14px;
						color: @color1;
						min-height: 40px;
						line-height: 40px;

						span {
							font-size: 12px;
							color: #A9A9A9;
							margin-left: 10px;
						}
					}

					.textarea {}

					.hwk-upload {
						display: flex;
						align-items: center;

						.uploads {
							display: flex;
							align-items: center;
							flex-wrap: wrap;
							text-align: center;

							.i {
								width: 60px;
								height: 60px;
								margin: 0 10px 10px 0;
								position: relative;
								border: 1px solid #eee;
								border-radius: 4px;

								.delete {
									position: absolute;
									width: 14px;
									height: 15px;
									top: 0;
									right: 0;
								}

								.img {
									position: relative;
									width: 100%;
									height: 100%;

									overflow: hidden;
								}

								.add {
									position: absolute;
									width: 30px;
									height: 30px;
									top: 50%;
									left: 50%;
									margin-top: -15px;
									margin-left: -15px;
								}
							}
						}

					}
				}
			}

			.apply-type {
				// margin-top: 20px;
				height: 40px;
				line-height: 40px;
				align-items: center;
				justify-content: space-between;

				.l {
					font-size: 14px;
					color: @color1;
					flex: 1;
					text-align: left;
				}

				.r {
					align-items: center;
					justify-content: flex-end;
					flex: 1;
					display: flex;

					.i {
						flex: 1;

						img {
							width: 15px;
							height: 15px;
							align-items: center;
							margin-right: 5px;
						}

						span {
							font-size: 14px;
							color: #3F3F3F;
						}
					}
				}
			}

			.gl {
				align-items: center;
				justify-content: space-between;
				width: 100%;
				height: 36px;
				line-height: 36px;
				background: #FFF5EE;
				border-radius: 6px;
				padding: 0 10px;

				.gl-l {
					text-align: left;
					font-size: 14px;
					color: @color1;
				}

				.gl-r {
					text-align: center;

					span {
						font-size: 14px;
						color: @color2;
						margin-right: 5px;
					}

					i {
						color: @color2;
					}
				}
			}

			.o-hd {
				display: flex;
				align-items: center;
				height: 30px;
				line-height: 30px;
				margin-top: 10px;

				img {
					width: 16px;
					height: 16px;
				}

				p {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					font-size: 14px;
					color: @color1;
					text-align: left;

					span {
						color: #3572F5;
						text-decoration-line: underline;
						margin-left: 10px;
					}
				}

			}

			.o-d-goods {
				.item {
					padding: 10px 0;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.price {
						width: 100px;

						p {
							font-size: 14px;
							color: @color1;
							text-align: left;
							line-height: 20px;
						}
					}

					.img {
						width: 50px;
						height: 50px;
						background: #FFFFFF;
						border-radius: 6px 6px 6px 6px;
						border: 1px solid #D8D8D8;
						overflow: hidden;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.con {
						flex: 1;
						width: 1px;
						margin-left: 10px;

						.name {

							font-weight: 500;
							font-size: 14px;
							color: @color1;
							line-height: 20px;
							text-align: left;

						}

						.p {
							font-size: 12px;
							color: #50607A;
							line-height: 20px;
							text-align: left;
						}
					}
				}

				.item1 {
					height: 40px;
					line-height: 40px;
					background-color: #F7F9FA;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.i {
						font-size: 14px;
						color: @color1;
						text-align: left;
						text-indent: 10px;
					}

					.i1 {
						flex: 1;
						width: 1px;
					}

					.i2 {
						width: 100px;
					}
				}
			}

			.o-d-title {
				font-weight: bold;
				font-size: 16px;
				color: #11192D;
				height: 30px;
				line-height: 30px;
				text-align: left;
			}

			.o-d-list {
				font-size: 14px;

				.i {
					color: #868E99;
					height: 30px;
					line-height: 30px;
					margin-right: 20px;

					span {
						color: @color1;
					}
				}
			}

			.hr {
				margin: 20px auto;
				width: 100%;
				height: 1px;
				background-color: #eee;
			}

			.btns {
				.btn {
					width: 90px;
					height: 34px;
					line-height: 34px;
					font-size: 14px;
					border-radius: 10px 10px 10px 10px;
					text-align: center;

				}

				.btn1 {
					background-color: @color2;
					color: #fff;
				}

				.btn2 {
					background: #FFFFFF;
					border: 1px solid #D8D8D8;
					margin-left: 10px;
				}
			}

			.address {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				position: relative;

				border: 1px solid #D8D8D8;
				padding: 20px;
				border-radius: 6px;

				.bh {
					position: absolute;
					right: 10px;
					top: 45px;
					width: 100px;
					height: 24px;
					line-height: 24px;
					font-weight: 500;
					font-size: 12px;
					color: #3572F5;
					text-align: right;
					text-decoration-line: underline;
				}

				.sh {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 10px;
					top: 5px;
					padding: 0 10px;
					height: 22px;
					line-height: 22px;
					text-align: center;
					border-radius: 11px;

					img {
						width: 15px;
						height: 15px;
						margin-right: 5px;
					}

					span {
						font-size: 12px;

					}
				}

				.sh1 {
					background: #FFE5E5;

					span {
						color: #FF1717;
					}
				}

				.sh2 {
					background: #EEFFF1;

					span {
						color: #34C759;
					}
				}

				.l {
					i {
						font-size: 24px;
						color: @color2;
					}
				}

				.r {
					flex: 1;
					width: 1px;
					margin-left: 10px;
					text-align: left;

					p {
						font-size: 14px;
						color: @color1;
						line-height: 24px;

						span {
							margin-right: 20px;
						}
					}
				}
			}

			.state {

				height: 40px;
				line-height: 40px;
				font-weight: 800;
				font-size: 28px;
				color: #FF6A00;
				text-align: left;
				margin-top: 20px;
			}

			.back {
				height: 30px;
				line-height: 30px;
				text-align: left;

				span {
					font-size: 16px;
					color: #11192D;
					margin-left: 5px;
				}

				&:hover {
					i {
						color: @color2;
					}

					span {
						color: @color2;
					}
				}
			}
		}

		.o-d-r {
			width: 370px;

			background: #FFFFFF;
			border-radius: 10px;
			border: 1px solid #EBEBEB;
			padding: 20px;
			box-sizing: border-box;

			.r-btns {
				align-items: center;
				justify-content: space-between;
				margin: 20px auto;
				text-align: center;

				.btn1 {
					width: 62px;
					height: 48px;
					line-height: 48px;
					background: #FFFFFF;
					border-radius: 10px 10px 10px 10px;
					border: 1px solid #D8D8D8;
					color: #868E99;
					font-size: 16px;
				}

				.btn2 {
					width: 248px;
					height: 48px;
					line-height: 48px;
					background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
					border-radius: 10px;
					opacity: 0.5;
					color: #fff;
					font-size: 16px;

				}
			}

			.title {

				height: 30px;
				line-height: 30px;
				font-weight: bold;
				font-size: 18px;
				color: @color1;
				text-align: left;
			}

			.hr {
				margin: 10px auto;
				width: 100%;
				height: 1px;
				background-color: #eee;
			}

			.list {
				margin-top: 10px;

				.item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					height: 34px;
					line-height: 34px;

					.l {
						text-align: left;
						font-size: 14px;
						color: #868E99;
					}

					.r {
						flex: 1;
						width: 1px;
						text-align: right;
						font-size: 14px;
						color: @color1;
						align-items: center;
						;
						justify-content: flex-end;

						span {
							font-size: 16px;
							font-weight: 600;
						}

						img {
							width: 15px;
							height: 15px;
							margin-left: 10px;
						}
					}
				}
			}
		}
	}

	.table-form {

		border-collapse: collapse;
		/* 关键：合并边框 */
		width: 100%;
		border: 1px solid #ccc;
		/* 可选：外边框 */
		margin-bottom: 20px;

		td {
			border: 1px solid #ccc;
			/* 细线边框 */
			padding: 10px;
		}
	}

	.el-form-item {
		margin-bottom: 0 !important;
	}

	.textarea {
		position: relative;

		.el-button {
			position: absolute;
			bottom: 10px;
			right: 10px;
		}
	}

	.tips {
		height: 30px;
		background: #FFF5EE;
		align-items: center;
		justify-content: space-between;
		line-height: 30px;
		margin: 10px auto;
		padding: 0 10px;
		border-radius: 3px;

		i {
			color: @color2;
		}

		span {
			flex: 1;
			width: 1px;
			margin-left: 10px;
			font-size: 12px;
			color: #868E99;
			text-align: left;
		}
	}
</style>